import React from 'react'
import styled from 'styled-components';

import { useRef, useEffect, useState } from 'react';

import * as d3 from 'd3';
import { useHorizontalScroll } from '../../../utils/HorizontalScrollHook';
import LabelText from '../../../ui/LabelText';
import { useTheme } from '../../../contexts/ThemeContext';
import Switch from '../../../ui/CustomSwitch';
import { IMatches } from '../../../types/IPlayerDetail';
import YellowCardSvg from '../../../assets/event_icons/Yellow Card.svg'
import RedCardSvg from "../../../assets/event_icons/Red Card.svg";
import Goal from "../../../assets/event_icons/Goal.svg";
import Assits from "../../../assets/event_icons/Assits.svg"
import LabelNumber from '../../../styled-components/LabelNumber';
import CustomDropdown from '../../../ui/CustomDropdown';
import { IOption } from '../../../types/IOption';
import { IValueGraphChart } from '../../../types/IValueGraphChart';


const BottomSideBar = styled.div`
  border-right :3px solid ${({ theme }) => theme.playerDataBorder}
`;
const BottomLeftContainer = styled.div`
  border-bottom :2px solid ${({ theme }) => theme.playerDataBorder}
`;
const MatchSvg = styled.svg`
  border-top :1px solid ${({ theme }) => theme.playerDataBorder}
`;
const ValueGraphContainer = styled.div`
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

const YAxisContainer = styled.div`
  position: sticky;
  left: 0;
  z-index: 0;
  width: 200px;
`;

const SvgStyled = styled.svg`
  border-top: 1px solid ${({ theme }) => theme.playerDataBorder};
`;


const Options: IOption[] = [
  { value: 'Football', label: 'Football' },
  { value: 'Financial', label: 'Financial' },
  { value: 'Market', label: 'Market' },
  { value: 'Commercial', label: 'Commercial' },
  { value: 'Attribute-score', label: 'Attribute score' },
]

const transferData: any = [
  {
    "seasonId": 185821,
    "seasonName": "2015/2016",
    "matches": [
      {
        "matchId": 2842601,
        "transferValue": 24953013,
        "transferValueText": "24.9M"
      },
      {
        "matchId": 2842602,
        "transferValue": 26501146,
        "transferValueText": "26.5M"
      },
      {
        "matchId": 2842603,
        "transferValue": 34063366,
        "transferValueText": "34M"
      }
    ]
  },
  {
    "seasonId": 185822,
    "seasonName": "2016/2017",
    "matches": [
      {
        "matchId": 2842604,
        "transferValue": 21818740,
        "transferValueText": "21.8M"
      },
      {
        "matchId": 2842605,
        "transferValue": 9842206,
        "transferValueText": "9.8M"
      },
      {
        "matchId": 2842606,
        "transferValue": 13048933,
        "transferValueText": "13M"
      }
    ]
  },
  {
    "seasonId": 185823,
    "seasonName": "2017/2018",
    "matches": [
      {
        "matchId": 2842607,
        "transferValue": 11229166,
        "transferValueText": "11.2M"
      },
      {
        "matchId": 2842608,
        "transferValue": 12336906,
        "transferValueText": "12.3M"
      },
      {
        "matchId": 2842609,
        "transferValue": 12240180,
        "transferValueText": "12.2M"
      },
    ]
  },
  {
    "seasonId": 185824,
    "seasonName": "2018/2019",
    "matches": [
      {
        "matchId": 2842610,
        "transferValue": 9266973,
        "transferValueText": "9.2M"
      },
      {
        "matchId": 2842611,
        "transferValue": 8484173,
        "transferValueText": "8.4M"
      },
      {
        "matchId": 2842612,
        "transferValue": 7451400,
        "transferValueText": "7.4M"
      }
    ]
  },
  {
    "seasonId": 185825,
    "seasonName": "2019/2020",
    "matches": [
      {
        "matchId": 2842613,
        "transferValue": 7330820,
        "transferValueText": "7.3M"
      },
      {
        "matchId": 2842614,
        "transferValue": 8234953,
        "transferValueText": "8.2M"
      },
      {
        "matchId": 2842615,
        "transferValue": 8628040,
        "transferValueText": "8.6M"
      }
    ]
  },
  {
    "seasonId": 185826,
    "seasonName": "2020/2021",
    "matches": [
      {
        "matchId": 2842616,
        "transferValue": 9350568,
        "transferValueText": "9.3M"
      },
      {
        "matchId": 2842617,
        "transferValue": 10162100,
        "transferValueText": "10.1M"
      },
      {
        "matchId": 2842618,
        "transferValue": 7436946,
        "transferValueText": "7.4M"
      }
    ]
  },
  {
    "seasonId": 185827,
    "seasonName": "2021/2022",
    "matches": [
      {
        "matchId": 2842619,
        "transferValue": 12349733,
        "transferValueText": "12.3M"
      },
      {
        "matchId": 2842620,
        "transferValue": 7209246,
        "transferValueText": "7.2M"
      },
      {
        "matchId": 2842621,
        "transferValue": 6744426,
        "transferValueText": "6.7M"
      },
    ]
  },
  {
    "seasonId": 185828,
    "seasonName": "2022/2023",
    "matches": [
      {
        "matchId": 2842622,
        "transferValue": 8226014,
        "transferValueText": "8.2M"
      },
      {
        "matchId": 2842623,
        "transferValue": 8584873,
        "transferValueText": "8.5M"
      },
      {
        "matchId": 2842624,
        "transferValue": 9811241,
        "transferValueText": "9.8M"
      },
    ]
  },
  {
    "seasonId": 185828,
    "seasonName": "2022/2023",
    "matches": [
      {
        "matchId": 2842625,
        "transferValue": 8226014,
        "transferValueText": "8.2M"
      },
      {
        "matchId": 2842626,
        "transferValue": 8584873,
        "transferValueText": "8.5M"
      },
      {
        "matchId": 2842627,
        "transferValue": 9811241,
        "transferValueText": "9.8M"
      }
    ]
  }
]

const data: any = [
  {
    "seasonId": 185821,
    "seasonName": "2015/2016",
    "matches": [
      {
        "matchId": 2842601,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 2,
        "goals": 3,
        "assists": 1,
        "avcontribution": 75,
        "avxgoals": 0.1,
        "avxassists": 0.01,
      },
      {
        "matchId": 2842602,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 2,
        "goals": 2,
        "assists": 0,
        "avcontribution": 60,
        "avxgoals": 0.2,
        "avxassists": 0.02,
      },
      {
        "matchId": 2842603,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 1,
        "goals": 1,
        "assists": 1,
        "avcontribution": 80,
        "avxgoals": 0.15,
        "avxassists": 0.03,
      }
    ]
  },
  {
    "seasonId": 185821,
    "seasonName": "2016/2017",
    "matches": [
      {
        "matchId": 2842604,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 2,
        "goals": 3,
        "assists": 1,
        "avcontribution": 75,
        "avxgoals": 0.1,
        "avxassists": 0.01,
      },
      {
        "matchId": 2842605,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 2,
        "goals": 2,
        "assists": 0,
        "avcontribution": 60,
        "avxgoals": 0.2,
        "avxassists": 0.02,
      },
      {
        "matchId": 2842606,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 1,
        "goals": 1,
        "assists": 1,
        "avcontribution": 80,
        "avxgoals": 0.15,
        "avxassists": 0.03,
      }
    ]
  },
  {
    "seasonId": 185822,
    "seasonName": "2017/2018",
    "matches": [
      {
        "matchId": 2842607,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 1,
        "goals": 2,
        "assists": 1,
        "avcontribution": 70,
        "avxgoals": 0.11,
        "avxassists": 0.01,
      },
      {
        "matchId": 2842608,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 3,
        "assists": 0,
        "avcontribution": 90,
        "avxgoals": 0.2,
        "avxassists": 0.03,
      },
      {
        "matchId": 2842609,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 4,
        "goals": 1,
        "assists": 2,
        "avcontribution": 65,
        "avxgoals": 0.1,
        "avxassists": 0.02,
      }
    ]
  },
  {
    "seasonId": 185823,
    "seasonName": "2018/2019",
    "matches": [
      {
        "matchId": 2842610,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 1,
        "assists": 2,
        "avcontribution": 65,
        "avxgoals": 0.1,
        "avxassists": 0.02,
      },
      {
        "matchId": 2842611,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 1,
        "goals": 3,
        "assists": 0,
        "avcontribution": 90,
        "avxgoals": 0.2,
        "avxassists": 0.03,
      },
      {
        "matchId": 2842612,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 0,
        "assists": 2,
        "avcontribution": 55,
        "avxgoals": 0.05,
        "avxassists": 0.04,
      }
    ]
  },
  {
    "seasonId": 185824,
    "seasonName": "2019/2020",
    "matches": [
      {
        "matchId": 2842613,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 1,
        "assists": 2,
        "avcontribution": 65,
        "avxgoals": 0.1,
        "avxassists": 0.02,
      },
      {
        "matchId": 2842614,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 1,
        "goals": 3,
        "assists": 0,
        "avcontribution": 90,
        "avxgoals": 0.2,
        "avxassists": 0.03,
      },
      {
        "matchId": 2842615,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 0,
        "assists": 2,
        "avcontribution": 55,
        "avxgoals": 0.05,
        "avxassists": 0.04,
      }
    ]
  },
  {
    "seasonId": 185824,
    "seasonName": "2020/2021",
    "matches": [
      {
        "matchId": 2842616,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 1,
        "assists": 2,
        "avcontribution": 65,
        "avxgoals": 0.1,
        "avxassists": 0.02,
      },
      {
        "matchId": 2842617,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 1,
        "goals": 3,
        "assists": 0,
        "avcontribution": 90,
        "avxgoals": 0.2,
        "avxassists": 0.03,
      },
      {
        "matchId": 2842618,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 0,
        "assists": 2,
        "avcontribution": 55,
        "avxgoals": 0.05,
        "avxassists": 0.04,
      }
    ]
  },
  {
    "seasonId": 185824,
    "seasonName": "2021/2022",
    "matches": [
      {
        "matchId": 2842619,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 1,
        "assists": 2,
        "avcontribution": 65,
        "avxgoals": 0.1,
        "avxassists": 0.02,
      },
      {
        "matchId": 2842620,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 1,
        "goals": 3,
        "assists": 0,
        "avcontribution": 90,
        "avxgoals": 0.2,
        "avxassists": 0.03,
      },
      {
        "matchId": 2842621,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 0,
        "assists": 2,
        "avcontribution": 55,
        "avxgoals": 0.05,
        "avxassists": 0.04,
      }
    ]
  },
  {
    "seasonId": 185824,
    "seasonName": "2022/2023",
    "matches": [
      {
        "matchId": 2842622,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 1,
        "assists": 2,
        "avcontribution": 65,
        "avxgoals": 0.1,
        "avxassists": 0.02,
      },
      {
        "matchId": 2842623,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 1,
        "goals": 3,
        "assists": 0,
        "avcontribution": 90,
        "avxgoals": 0.2,
        "avxassists": 0.03,
      },
      {
        "matchId": 2842624,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 0,
        "assists": 2,
        "avcontribution": 55,
        "avxgoals": 0.05,
        "avxassists": 0.04,
      }
    ]
  },
  {
    "seasonId": 185825,
    "seasonName": "2023/2024",
    "matches": [
      {
        "matchId": 2842625,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 1,
        "assists": 2,
        "avcontribution": 65,
        "avxgoals": 0.1,
        "avxassists": 0.02,
      },
      {
        "matchId": 2842626,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 1,
        "goals": 3,
        "assists": 0,
        "avcontribution": 90,
        "avxgoals": 0.2,
        "avxassists": 0.03,
      },
      {
        "matchId": 2842627,
        "teamId": 2481,
        "imageDataUrl": "https://cdn5.wyscout.com/photos/team/public/341_120x120.png",
        "daysInjured": 0,
        "goals": 0,
        "assists": 2,
        "avcontribution": 55,
        "avxgoals": 0.05,
        "avxassists": 0.04,
      }
    ]
  }
];



const ValueGraphChartForThirds: React.FC<IValueGraphChart> = ({ transferValueData, isFullView }) => {
  const scrollRef = useHorizontalScroll();
  const { theme } = useTheme()
  const svgRef = useRef<SVGSVGElement>(null);
  const yAxisRef = useRef<SVGSVGElement>(null);
  const daysInjuredRef = useRef<SVGSVGElement | null>(null);
  const goalsRef = useRef<SVGSVGElement | null>(null);
  const AssistsRef = useRef<SVGSVGElement | null>(null);
  const seasonRef = useRef<SVGSVGElement | null>(null);
  const avxgoalsRef = useRef<SVGSVGElement | null>(null);
  const avxassistsRef = useRef<SVGSVGElement | null>(null);
  const leagueRef = useRef<SVGSVGElement | null>(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const resizeObserver = new ResizeObserver(entries => {
      if (entries.length > 0) {
        const { width, height } = entries[0].contentRect;
        if (width !== dimensions.width || height !== dimensions.height) {
          setDimensions({ width, height });
        }
      }
    });

    if (svgRef.current && yAxisRef.current) {
      resizeObserver.observe(svgRef.current.parentElement!);
    }

    return () => resizeObserver.disconnect();
  }, [dimensions.width, dimensions.height]);

  useEffect(() => {
    if (!svgRef.current || !yAxisRef.current || transferValueData === undefined) return;
    const svg = d3.select(svgRef.current);
    const yAxisSvg = d3.select(yAxisRef.current);

    const margin = { top: 40, right: 0, bottom: 0, left: 0 };
    const { width, height } = dimensions;

    let totalMatches = data.reduce((sum: any, season: any) => sum + season.matches.length, 0);;
    const minRectWidth = 60;
    const gapBetweenSeasons = 30;

    // data.forEach((season: any) => {
    //   totalMatches += season.matches.length;
    // });
    const numberOfSeasons = data.length;
    const numberOfGaps = numberOfSeasons - 1;
    const minTotalWidth = (totalMatches * minRectWidth) + (numberOfGaps * gapBetweenSeasons);
    const svgWidth = Math.max(1580, minTotalWidth);
    const rectWidth = svgWidth > 1580 ? minRectWidth : (1580 - (numberOfGaps * gapBetweenSeasons)) / totalMatches;

    //const totalWidth = Math.max(1580, (totalMatches * rectWidth) + (numberOfGaps * gapBetweenSeasons));
    const x = d3.scaleBand<number>()
      .domain(transferData.flatMap((season: any) => season.matches.map((d: any) => d.matchId)))
      .range([0, svgWidth])

    const y = d3.scaleLinear()
      .domain([d3.min(transferValueData?.yAxisDivisions!, d => d.value)!, d3.max(transferValueData?.yAxisDivisions!, d => d.value)!])
      .range([height - margin.top - margin.bottom, 0]);

    svg.attr('width', svgWidth).attr('height', height);
    yAxisSvg.attr('width', 200).attr('height', height);

    const seasonSvg = d3.select(seasonRef.current)
      .attr('width', svgWidth + margin.left + margin.right)
      .attr('height', 84);

    const daysInjuredSvg = d3.select(daysInjuredRef.current)
      .attr('width', svgWidth + margin.left + margin.right)
      .attr('height', 50);

    const goalSvg = d3.select(goalsRef.current)
      .attr('width', svgWidth + margin.left + margin.right)
      .attr('height', 50);

    const assistsSvg = d3.select(AssistsRef.current)
      .attr('width', svgWidth + margin.left + margin.right)
      .attr('height', 50);

    const avxGoalsSvg = d3.select(avxgoalsRef.current)
      .attr('width', svgWidth + margin.left + margin.right)
      .attr('height', 50);

    const avxAssistsSvg = d3.select(avxassistsRef.current)
      .attr('width', svgWidth + margin.left + margin.right)
      .attr('height', 50);

    svg.selectAll("*").remove();
    yAxisSvg.selectAll("*").remove();
    daysInjuredSvg.selectAll("*").remove();
    goalSvg.selectAll("*").remove();
    assistsSvg.selectAll("*").remove();
    avxGoalsSvg.selectAll("*").remove();
    avxAssistsSvg.selectAll("*").remove();

    const yMainFGroup = yAxisSvg.append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const yAxisLineGroup = yMainFGroup.append('g');

    // Add Y-axis text labels
    transferValueData?.yAxisDivisions.forEach(d => {
      yMainFGroup.append("text")
        .attr("x", 160) // Adjust X position as needed
        .attr("y", y(d.value) - 15)
        .attr("text-anchor", "end")
        .attr("dy", ".35em")
        .style("fill", theme.playerColor) // Change to your theme color
        .style("font-size", "20px")
        .style("font-family", "DM Mono")
        .style("font-weight", 500)
        .text(d.text);
      // Add horizontal y grid lines
      yAxisLineGroup.append('line')
        .attr('class', 'horizontal-line')
        .attr('x1', -180)
        .attr('x2', svgWidth)
        .attr('y1', y(d.value))
        .attr('y2', y(d.value))
        .attr('stroke', theme.playerDataBorder)
        .attr('stroke-width', 1);
    });

    // Add the Y Axis with shadow effect
    yAxisLineGroup.append("line")
      .attr('x1', 198)
      .attr('y1', 0 - 40)
      .attr('x2', 198)
      .attr('y2', height + margin.top - margin.bottom)
      .style('stroke', theme.playerDataBorder)
      .style('stroke-width', 3);

    // Flatten data and draw the continuous line path
    const flattenedData = transferData.flatMap((season: any) => season.matches.map((match: any) => ({
      ...match,
      seasonName: season.seasonName
    })));

    let xPosition = 0;

    data.forEach((season: any, seasonIndex: number) => {
      const seasonWidth = season.matches.length * rectWidth; // Total width of the season matches
      const seasonMidpoint = xPosition + seasonWidth / 2;

      season.matches.forEach((match: any, matchIndex: number) => {

        svg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", minRectWidth)
          .attr("height", height + margin.top - margin.bottom)
          .attr("fill", theme.playerCardBackground);

        seasonSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", minRectWidth)
          .attr("height", height)
          .attr("fill", theme.playerCardBackground);

        daysInjuredSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", minRectWidth)
          .attr("height", height)
          .attr("fill", theme.playerCardBackground);

        goalSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", minRectWidth)
          .attr("height", height)
          .attr("fill", theme.playerCardBackground);

        assistsSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", minRectWidth)
          .attr("height", height)
          .attr("fill", theme.playerCardBackground);

        avxGoalsSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", minRectWidth)
          .attr("height", height)
          .attr("fill", theme.playerCardBackground);

        avxAssistsSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", minRectWidth)
          .attr("height", height)
          .attr("fill", theme.playerCardBackground);

        daysInjuredSvg.append("text")
          .attr("x", xPosition + minRectWidth / 2)  // Center the text horizontally
          .attr("y", 25)  // Center the text vertically
          .attr("text-anchor", "middle")  // Align text in the center
          .attr("fill", "black")  // Text color
          .attr("font-size", "12px")  // Font size
          .attr("dy", ".35em")  // Vertical alignment
          .text(match.daysInjured);

        goalSvg.append("text")
          .attr("x", xPosition + minRectWidth / 2)  // Center the text horizontally
          .attr("y", 25)  // Center the text vertically
          .attr("text-anchor", "middle")  // Align text in the center
          .attr("fill", "black")  // Text color
          .attr("font-size", "12px")  // Font size
          .attr("dy", ".35em")  // Vertical alignment
          .text(match.goals);

        assistsSvg.append("text")
          .attr("x", xPosition + minRectWidth / 2)  // Center the text horizontally
          .attr("y", 25)  // Center the text vertically
          .attr("text-anchor", "middle")  // Align text in the center
          .attr("fill", "black")  // Text color
          .attr("font-size", "12px")  // Font size
          .attr("dy", ".35em")  // Vertical alignment
          .text(match.assists);

        avxGoalsSvg.append("text")
          .attr("x", xPosition + minRectWidth / 2)  // Center the text horizontally
          .attr("y", 25)  // Center the text vertically
          .attr("text-anchor", "middle")  // Align text in the center
          .attr("fill", "black")  // Text color
          .attr("font-size", "12px")  // Font size
          .attr("dy", ".35em")  // Vertical alignment
          .text(match.avxgoals);

        avxAssistsSvg.append("text")
          .attr("x", xPosition + minRectWidth / 2)  // Center the text horizontally
          .attr("y", 25)  // Center the text vertically
          .attr("text-anchor", "middle")  // Align text in the center
          .attr("fill", "black")  // Text color
          .attr("font-size", "12px")  // Font size
          .attr("dy", ".35em")  // Vertical alignment
          .text(match.avxassists);

        if (matchIndex < season.matches.length - 1) {
          svg.append("line")
            .attr("x1", xPosition + minRectWidth)  // Line starts at the right edge of the match rectangle
            .attr("x2", xPosition + minRectWidth)  // Same x position for the top and bottom of the line
            .attr("y1", 469)  // Top position of the line (same as the top of the rect)
            .attr("y2", 0)  // Bottom position of the line (same as the bottom of the rect)
            .attr("stroke", theme.playerDataBorder)  // Line color
            .attr("stroke-width", 2);

          seasonSvg.append("line")
            .attr("x1", xPosition + minRectWidth)  // Line starts at the right edge of the match rectangle
            .attr("x2", xPosition + minRectWidth)  // Same x position for the top and bottom of the line
            .attr("y1", 82)  // Top position of the line (same as the top of the rect)
            .attr("y2", 0)  // Bottom position of the line (same as the bottom of the rect)
            .attr("stroke", theme.playerDataBorder)  // Line color
            .attr("stroke-width", 2);

          daysInjuredSvg.append("line")
            .attr("x1", xPosition + minRectWidth)  // Line starts at the right edge of the match rectangle
            .attr("x2", xPosition + minRectWidth)  // Same x position for the top and bottom of the line
            .attr("y1", 48)  // Top position of the line (same as the top of the rect)
            .attr("y2", 0)  // Bottom position of the line (same as the bottom of the rect)
            .attr("stroke", theme.playerDataBorder)  // Line color
            .attr("stroke-width", 2);  // Line thickness

          goalSvg.append("line")
            .attr("x1", xPosition + minRectWidth)  // Line starts at the right edge of the match rectangle
            .attr("x2", xPosition + minRectWidth)  // Same x position for the top and bottom of the line
            .attr("y1", 48)  // Top position of the line (same as the top of the rect)
            .attr("y2", 0)  // Bottom position of the line (same as the bottom of the rect)
            .attr("stroke", theme.playerDataBorder)  // Line color
            .attr("stroke-width", 2);  // Line thickness

          assistsSvg.append("line")
            .attr("x1", xPosition + minRectWidth)  // Line starts at the right edge of the match rectangle
            .attr("x2", xPosition + minRectWidth)  // Same x position for the top and bottom of the line
            .attr("y1", 48)  // Top position of the line (same as the top of the rect)
            .attr("y2", 0)  // Bottom position of the line (same as the bottom of the rect)
            .attr("stroke", theme.playerDataBorder)  // Line color
            .attr("stroke-width", 2);

          avxGoalsSvg.append("line")
            .attr("x1", xPosition + minRectWidth)  // Line starts at the right edge of the match rectangle
            .attr("x2", xPosition + minRectWidth)  // Same x position for the top and bottom of the line
            .attr("y1", 48)  // Top position of the line (same as the top of the rect)
            .attr("y2", 0)  // Bottom position of the line (same as the bottom of the rect)
            .attr("stroke", theme.playerDataBorder)  // Line color
            .attr("stroke-width", 2);

          avxAssistsSvg.append("line")
            .attr("x1", xPosition + minRectWidth)  // Line starts at the right edge of the match rectangle
            .attr("x2", xPosition + minRectWidth)  // Same x position for the top and bottom of the line
            .attr("y1", 48)  // Top position of the line (same as the top of the rect)
            .attr("y2", 0)  // Bottom position of the line (same as the bottom of the rect)
            .attr("stroke", theme.playerDataBorder)  // Line color
            .attr("stroke-width", 2);
        }

        xPosition += minRectWidth; // Increment x position for each match



      });


      if (seasonIndex < data.length - 1) {
        svg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", gapBetweenSeasons)
          .attr("height", height)
          .attr("fill", theme.playerContentBackground);

        seasonSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", gapBetweenSeasons)
          .attr("height", height)
          .attr("fill", theme.playerContentBackground);
        // Add a gap after the last match of each season
        daysInjuredSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", gapBetweenSeasons)
          .attr("height", height)
          .attr("fill", theme.playerContentBackground);

        goalSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", gapBetweenSeasons)
          .attr("height", height)
          .attr("fill", theme.playerContentBackground);

        assistsSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", gapBetweenSeasons)
          .attr("height", height)
          .attr("fill", theme.playerContentBackground);
        avxGoalsSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", gapBetweenSeasons)
          .attr("height", height)
          .attr("fill", theme.playerContentBackground);
        avxAssistsSvg.append("rect")
          .attr("x", xPosition)
          .attr("y", 0)
          .attr("width", gapBetweenSeasons)
          .attr("height", height)
          .attr("fill", theme.playerContentBackground);

        // Add a gap after the last match of each season
        xPosition += gapBetweenSeasons;
      }
      seasonSvg.append("text")
        .attr("x", seasonMidpoint)
        .attr("y", 41)
        .attr("text-anchor", "middle")
        .attr("font-size", "16px")
        .attr("fill", "black")
        .text(season.seasonName);
    });

    const line = d3.line<any>()
      .x(d => x(d.matchId)! + x.bandwidth() / 2)
      .y(d => y(d.transferValue))
      .curve(d3.curveMonotoneX);

    // Append path to the main group
    svg.append("path")
      .datum(flattenedData)
      .attr("fill", "none")
      .attr("stroke", "#00D1A8")
      .attr("stroke-width", 4)
      .attr("d", line);

    const yValues = transferValueData?.yAxisDivisions.map(d => d.value);

    for (let i = 0; i < (yValues.length); i++) {
      svg.append('line')
        .attr('class', 'horizontal-line')
        .attr('x1', -180)
        .attr('x2', svgWidth)
        .attr('y1', y(yValues[i]))
        .attr('y2', y(yValues[i]))
        .attr('stroke', theme.playerDataBorder)
        .attr('stroke-width', 1);
    }

  }, [dimensions, transferValueData, theme]);

  return (
    <div className={`value-graph-chart ${isFullView && 'fullview-chart'} `}>
      <YAxisContainer>
        <SvgStyled ref={yAxisRef} />
        <BottomSideBar className='bottom-sidebar'>
          <BottomLeftContainer className='third-season'>
            {isFullView && (
              <div className='drivers-matches'>
                <LabelNumber className='club-info-value'>Drivers</LabelNumber>
                <CustomDropdown options={Options}
                  deafaultSelected='Football' />
              </div>
            )}
          </BottomLeftContainer>
          {isFullView && (
            <>
              <BottomLeftContainer className='days-injured'>
                <div className='drivers-matches'>
                  <LabelText className='overall-text'>Days injured</LabelText>
                </div>
              </BottomLeftContainer>
              <BottomLeftContainer className='third-of-goals'>
                <div className='drivers-matches'>
                  <LabelText className='overall-text'>Goals</LabelText>
                </div>
              </BottomLeftContainer>
              <BottomLeftContainer className='third-of-assists'>
                <div className='drivers-matches'>
                  <LabelText className='overall-text'>Assists</LabelText>
                </div>
              </BottomLeftContainer>
              {/* <BottomLeftContainer className='third-of-avcontribution'>
                <div className='drivers-matches'>
                  <LabelText className='overall-text'>Av. Contribution</LabelText>
                </div>
              </BottomLeftContainer> */}
              <BottomLeftContainer className='third-of-avxgoals'>
                <div className='drivers-matches'>
                  <LabelText className='overall-text'>av. x Goals</LabelText>
                </div>
              </BottomLeftContainer>
              <BottomLeftContainer className='third-of-avxassists'>
                <div className='drivers-matches'>
                  <LabelText className='overall-text'>av. x Assists</LabelText>
                </div>
              </BottomLeftContainer>

            </>
          )}
          <BottomLeftContainer className='third-of-league'>
          </BottomLeftContainer>
        </BottomSideBar>
      </YAxisContainer>

      <div className={isFullView ? 'scrollbar-container-fullview' : 'scrollbar-container'}>
        <div className='testing'>
          <div className='value-graph-chart-top-svg'><SvgStyled ref={svgRef} /></div>
          <div className='value-graph-chart-bottom-svg'>
            <div className='third-season'><MatchSvg ref={seasonRef} /></div>
            {isFullView && (
              <>
                <div className='days-injured-svg'><MatchSvg ref={daysInjuredRef} /></div>
                <div className='days-injured-svg'><MatchSvg ref={goalsRef} /></div>
                <div className='days-injured-svg'><MatchSvg ref={AssistsRef} /></div>
                {/* <div className='third-of-avcontribution'><MatchSvg ref={avcontributionRef} /></div> */}
                <div className='days-injured-svg'><MatchSvg ref={avxgoalsRef} /></div>
                <div className='days-injured-svg'><MatchSvg ref={avxassistsRef} /></div>
              </>
            )}
            <div className='third-of-league'><MatchSvg ref={leagueRef} /></div>
          </div>
        </div>
      </div>
    </div>
  )

}

export default ValueGraphChartForThirds
